module.exports = __webpack_public_path__ + "img/15_en.8d4f8858.png";